export default "__VITE_ASSET__BFbClKBk__"